import * as S from "components/common/Banner/Overlay.style";

const CnpHoldingOverlayMobile = () => (
  <S.Overlay>
    <S.TextBanner variant="headline-01" color="white">
      <S.MainInfo>
        Somos a CNP Seguros Holding Brasil
      </S.MainInfo>
    </S.TextBanner>
    <S.TextBanner variant="headline-01" color="white">
      <S.SecondaryInfo>
        Mas pode nos chamar de CSH
      </S.SecondaryInfo>
    </S.TextBanner>
    <S.BannerIndicator />
  </S.Overlay>
);
export default CnpHoldingOverlayMobile;
